// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#welcome_assistant input[type=text], #welcome_assistant input[type=email], #welcome_assistant input[type=tel] {
    border: none !important;
    color: #262527;
}

#welcome_assistant input:-webkit-autofill,
#welcome_assistant input:-webkit-autofill:hover,
#welcome_assistant input:-webkit-autofill:focus,
#welcome_assistant input:-webkit-autofill:active {
    -webkit-background-clip: text;
    transition: background-color 100s ease-in-out 0s;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;;;IAII,6BAA6B;IAC7B,gDAAgD;AACpD","sourcesContent":["#welcome_assistant input[type=text], #welcome_assistant input[type=email], #welcome_assistant input[type=tel] {\n    border: none !important;\n    color: #262527;\n}\n\n#welcome_assistant input:-webkit-autofill,\n#welcome_assistant input:-webkit-autofill:hover,\n#welcome_assistant input:-webkit-autofill:focus,\n#welcome_assistant input:-webkit-autofill:active {\n    -webkit-background-clip: text;\n    transition: background-color 100s ease-in-out 0s;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
